<div class="dialog-content-wrapper"> 
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{data.titulo}}</span>
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="p-24 pb-0 m-0">
        <div class="box">
            <div class="box-item"></div>
            <div class="box-item">
                <mat-spinner></mat-spinner>
            </div>
            <div class="box-item"></div>
        </div>
        <br/>
        <div class="box">
            <div class="box-item text-center">
                <label>{{data.mensaje}}</label>
            </div>
        </div>
        <br/>
    </div>
</div>